<template>
  <div class="sage-export-pending-dialog-container">
    <div class="info-banner">
      <span :class="[infoIcon, 'info-icon']" />
      <span class="info-title">{{ texts.title }}</span>
    </div>

    <div class="dialog-body">
      <p class="description">{{ texts.description }}</p>
      <p class="records-included">{{ texts.recordsIncluded }}</p>
      <p class="records-line">{{ texts.recordsLine }}</p>
    </div>

    <CustomDialogActionButtonsComponent
      :primaryButtonText="texts.primaryButton"
      :secondaryButtonText="texts.secondaryButton"
      :mainAction="onAccept"
      :showSecondaryButton="true"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n-composable'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { Icons } from '@/icons/icons'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import { changeDateFormat } from '@/helpers/dateTime'

const { t } = useI18n()

const props = defineProps<{
  componentProps: {
    summary?: { total?: { value?: string }; fechaMin?: { value?: string }; fechaMax?: { value?: string } }
    onAccept?: () => void
  }
}>()

const summary = props.componentProps?.summary
const infoIcon = Icons.INFO_FULL

const getRecordsLineParams = () => ({
  count: summary?.total?.value ?? 0,
  fromDate: summary?.fechaMin?.value ? changeDateFormat(summary.fechaMin.value, 'YYYY-MM-DD', 'DD/MM/YYYY') : '',
  toDate: summary?.fechaMax?.value ? changeDateFormat(summary.fechaMax.value, 'YYYY-MM-DD', 'DD/MM/YYYY') : ''
})

const texts = {
  title: t('components.expedient_economic_data.sage_export_pending_title').toString(),
  description: t('components.expedient_economic_data.sage_export_pending_description').toString(),
  recordsIncluded: t('components.expedient_economic_data.sage_export_pending_records_included').toString(),
  recordsLine: t('components.expedient_economic_data.sage_export_pending_records_line', getRecordsLineParams()).toString(),
  primaryButton: t('action_buttons.export_for_sage').toString(),
  secondaryButton: t('action_buttons.cancel').toString()
}

const onAccept = () => {
  store.dispatch(`${ModuleNamespaces.DIALOG}/closeCustomDialog`)
  props.componentProps?.onAccept?.()
}
</script>

<style scoped lang="scss">
.sage-export-pending-dialog-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: $spacing-md;
}

.info-banner {
  display: flex;
  align-items: center;
  gap: $spacing-xs;
  padding: $spacing-xs $spacing-sm;
  background-color: $tertiary-byzantineBlue-050;
  border-radius: $cornerRadius-sm;

  .info-icon {
    color: $tertiary-byzantineBlue-200;
    font-size: 22px;
  }

  .info-title {
    @include milano-bold-16;
    color: $black-02;
  }
}

.dialog-body {
  padding: 0 $spacing-sm;

  .description {
    @include milano-regular-14;
    margin-bottom: $spacing-md;
  }

  .records-included {
    @include milano-bold-14;
    margin-bottom: $spacing-xs;
  }

  .records-line {
    @include milano-regular-14;
    margin-bottom: 0;
  }
}
</style>
